import PropTypes from 'prop-types';

const ColourIndicator = ({ colour, label }) => {
  return (
    <div className="wrapper">
      <div
        style={{
          backgroundColor: colour,
        }}
        className="colour-box"
      />
      <p className="label-styling">{label}</p>
    </div>
  );
};

ColourIndicator.propTypes = {
  label: PropTypes.string,
  colour: PropTypes.string,
};

ColourIndicator.defaultProps = {
  label: '',
  colour: '',
};
export default ColourIndicator;
